import TabModulesTemplate from "components/Modules/TabModulesTemplate"
import { withRouter } from "react-router-dom"
import CityNotificationsForm from "./_tabs/CityNotificationsForm"
import CityNotificationsTable from "./_tabs/CityNotificationsTable"

const CityNotifications = () => {
  return (
    <TabModulesTemplate
      documentTabs={[
        {
          label: "Form",
          Component: opened => <CityNotificationsForm opened={opened} />,
        },
      ]}
      collectionTabs={[
        {
          label: "Table",
          Component: () => <CityNotificationsTable />,
        },
      ]}
    />
  )
}

export default withRouter(CityNotifications)
